import * as yup from 'yup';

export const LoginSchema = yup.object({
  username: yup.string().required('Username is required'),
  password: yup.string().min(6).max(16).required('Password is required'),
});
